import { render, staticRenderFns } from "./BlockPartners.vue?vue&type=template&id=0358ef67&"
import script from "./BlockPartners.vue?vue&type=script&lang=js&"
export * from "./BlockPartners.vue?vue&type=script&lang=js&"
import style0 from "./BlockPartners.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports